import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { PITLSummaryActionButton } from '../../components/ActionButtons';
import { requestRecollection } from '../../util/apiUtils';
import { getCustomerCareNumber } from '../../util/gearOrderUtil';

/**
 * Creates an ActionButton that will begin the re-collection process
 *
 * @param gearOrder The gear order
 * @param gearReqId The ID of the gear req to re-collect
 * @param setActionResponse A function to pass any messages that need to be displayed
 * @param setLoading A function to call to display a loading shield and spinner
 * @param setGearOrder A function to pass the updated gearOrder back up the tree
 */
export const RecollectionAction = ({ gearOrder, gearReqId, setActionResponse, setLoading, setGearOrder }) => {
	const history = useHistory();
	const location = useLocation();

	const redirectToConfirm = () => {
		let url = `/order/${gearOrder.id}/confirm`;
		if (location?.search) {
			url += location.search;
		} else {
			url += `?dateOfBirth=${gearOrder?.patientInfo?.dateOfBirth}`;
		}
		history.push(url);
	};

	const handleClick = () => {
		setLoading(true);
		requestRecollection(gearOrder.id, gearOrder?.patientInfo?.dateOfBirth, [gearReqId])
			.then((json) => {
				setGearOrder(json);
				redirectToConfirm(json.id);
			})
			.catch((e) => {
				setActionResponse({
					status: 'danger',
					message: `An unexpected error has occurred. Please try again or call us at ${getCustomerCareNumber(gearOrder)} if the issue continues.`
				});
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return <PITLSummaryActionButton title="Request New Collection Pack" onClick={handleClick} />;
};
